"use client";
import { jsxs as f, Fragment as V, jsx as e } from "react/jsx-runtime";
import { Slot as k } from "@radix-ui/react-slot";
import { Root as y, Action as A, Close as I, Viewport as d, Provider as R } from "@radix-ui/react-toast";
import { cva as g } from "class-variance-authority";
import * as p from "react";
import { Close as j, Microphone as z, InformationCircle as M, CheckCircle as P, WarningCircle as m } from "@videoblocks/react-icons";
import { cn as n } from "./index22.mjs";
import { Text as S } from "./index4.mjs";
const W = g(
  "flex p-6 justify-between items-start rounded-sm border-l-8 shadow-level3-soft data-[state=open]:animate-in data-[state=open]:slide-in-from-right",
  {
    variants: {
      variant: {
        error: "border-l-red-500 bg-red-100 text-red-500",
        warning: "border-l-orange-500 bg-orange-100 text-orange-500",
        success: "border-l-green-500 bg-green-100 text-green-500",
        info: "border-l-blue-500 bg-blue-100 text-blue-500",
        neutral: "border-l-gray-500 bg-gray-200 text-black"
      }
    }
  }
), u = g("", {
  variants: {
    variant: {
      error: "fill-red-500",
      warning: "fill-orange-500",
      success: "fill-green-500",
      info: "fill-blue-500",
      neutral: "fill-black"
    }
  }
}), D = {
  error: m,
  warning: m,
  success: P,
  info: M,
  neutral: z
}, F = (t) => {
  const r = t || "neutral", a = D[r];
  return /* @__PURE__ */ e(a, { className: n("w-6 h-6", u({ variant: r })) });
}, $ = p.forwardRef(
  ({
    actionAltText: t,
    asChild: r = !1,
    actionProps: a = {},
    children: s,
    className: x = "",
    duration: b = 2e4,
    title: i,
    variant: o = "neutral",
    viewportClassName: l,
    viewportProps: c,
    ...h
  }, v) => {
    const w = r ? k : "a", { altText: N, ...C } = a, T = t || N || "";
    return /* @__PURE__ */ f(V, { children: [
      /* @__PURE__ */ e(
        y,
        {
          className: n(W({ variant: o }), x),
          duration: b,
          "data-variant": o,
          role: "status",
          ...h,
          children: /* @__PURE__ */ f("div", { className: "flex items-center gap-3 flex-1", children: [
            /* @__PURE__ */ e("div", { className: "flex-shrink-0", children: F(o) }),
            i && /* @__PURE__ */ e(S, { fontSize: "sm", fontWeight: "regular", children: i }),
            s && /* @__PURE__ */ e(
              A,
              {
                ref: v,
                className: "text-sm font-bold underline hover:no-underline cursor-pointer",
                altText: T,
                asChild: r,
                ...C,
                children: /* @__PURE__ */ e(w, { children: s })
              }
            ),
            /* @__PURE__ */ e(
              I,
              {
                className: "flex-shrink-0 p-1 hover:bg-gray-100 rounded transition-colors ml-auto",
                "aria-label": "Close",
                children: /* @__PURE__ */ e(j, { className: n("w-3 h-3", u({ variant: o })) })
              }
            )
          ] })
        }
      ),
      (l || c) && /* @__PURE__ */ e(d, { className: l, ...c })
    ] });
  }
);
$.displayName = "Toast";
const q = p.forwardRef(({ className: t, ...r }, a) => /* @__PURE__ */ e(d, { ref: a, className: n("fixed top-[var(--spacing-24)] right-[var(--spacing-6)] flex flex-col gap-[var(--spacing-2)] w-[var(--breakpoint-sm)] max-w-[calc(100vw-var(--spacing-12))] m-0 list-none z-[1050] outline-none", t), ...r }));
q.displayName = "ToastViewport";
const O = ({ children: t, ...r }) => /* @__PURE__ */ e(R, { swipeDirection: "right", ...r, children: t });
export {
  $ as Toast,
  O as ToastProvider,
  q as ToastViewport
};
